import { ta } from '@/config/tracking';

export const track = (eventName: string, properties?: Record<string, any>) => {
  ta.track(eventName, properties || {});
};